import Breadcrumb from "../components/Breadcrumb";
import DashboardLayer from "../components/child/DashboardLayer";

const Dashboard = () => {
  return (
    <>
        {/* Breadcrumb */}
        <Breadcrumb title='Overview' />

        {/* Dashboard */}
        <DashboardLayer />
    </>
  );
};

export default Dashboard;